import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import { RESEARCH_SUBNAV_CONTENT_PATH } from 'client/data/constants/contents-paths';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { ResearchSubnav } from 'site-modules/shared/components/editorial/research-subnav/research-subnav';

export function ResearchSharedSubnavUI({ content = DEFAULT_CONTENT, pathname = null, itemTrackingId = null }) {
  const subnavContent = content.child('subnav');
  const subnavHeading = subnavContent.metadata('subnavTitle').value();
  const subnavLinks = subnavContent.links();

  return (
    <Fragment>
      <hr className="mt-lg-0" />
      <ResearchSubnav
        className="px-1"
        heading={subnavHeading}
        links={subnavLinks}
        pathname={pathname}
        itemTrackingId={itemTrackingId}
      />
      <hr className="mt-0 mb-2" />
    </Fragment>
  );
}

ResearchSharedSubnavUI.propTypes = {
  content: CmsEntities.Content,
  pathname: PropTypes.string,
  itemTrackingId: PropTypes.string,
};

const mapStateToProps = state => ({
  pathname: get(state, 'pageContext.location.pathname'),
});

export const ResearchSharedSubnav = connect(mapStateToProps)(
  connectToModel(ResearchSharedSubnavUI, {
    content: bindToContent(RESEARCH_SUBNAV_CONTENT_PATH, 'right-rail-sub-nav'),
  })
);
